import type { ProductHomologationByStatus } from '@/components/ProductCard/types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HomologationCountriesCount } from './HomologationCountriesCount'
import { HomologationModal } from './HomologationModal'
import { HomologationStatus } from './HomologationStatus'
import { useManufactureHomologation } from './useManufactureHomologation'

import './homologation.scss'
import './product-manufacture.scss'

export function ManufactureHomologation({
  homologatedCountries,
}: Readonly<{
  homologatedCountries: ProductHomologationByStatus
}>) {
  const { t } = useTranslation()
  const [openModal, setOpenModal] = useState(false)
  const {
    selectedCountry,
    status,
    hasHomologationData,
    homologatedCountriesCount,
    countriesCount,
  } = useManufactureHomologation(homologatedCountries)

  const renderContent = () => {
    if (!hasHomologationData)
      return t('products-page.product-card.no-data')

    if (selectedCountry) {
      return <HomologationStatus status={status} onOpenModal={() => setOpenModal(true)} />
    }

    return (
      <HomologationCountriesCount
        homologatedCountriesCount={homologatedCountriesCount}
        countriesCount={countriesCount}
        onOpenModal={() => setOpenModal(true)}
      />
    )
  }

  return (
    <div className="product-homologation">
      <HomologationModal
        homologatedCountries={homologatedCountries}
        openModal={openModal}
        validate={() => setOpenModal(false)}
        setOpenModal={setOpenModal}
      />
      <span className="product-card-manufacture-labels">
        {t(`products-page.product-card.${selectedCountry ? 'homologation-status' : 'homologated-from'}`)}
      </span>
      {renderContent()}
    </div>
  )
}
